export default {
  get_all: { method: "get", url: "api/cidades" },
  show: { method: "get", url: "api/cidades{/id}" },
  store: { method: "post", url: "api/cidades" },
  update: { method: "put", url: "api/cidades{/id}" },
  delete: { method: "delete", url: "api/cidades{/id}" },

  get_all_estados: { method: "get", url: "api/estados" },
  show_estados: { method: "get", url: "api/estados{/sigla}" },

  get_all_paises: { method: "get", url: "api/paises" },
  show_pais: { method: "get", url: "api/paises{/iso3}" }
};
